export default function Pandas_Tutorial() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Pandas_Tutorial</h1>
      <p>Content for Pandas_Tutorial goes here.</p>
    </div>
  );
}